import api from './axios';

export const getPaymentSettings = async () => {
  const response = await api.get('/payments/settings');
  return response.data;
};

export const savePaymentSettings = async (settings) => {
  const response = await api.post('/payments/settings', settings);
  return response.data;
};

export const getProdamusSettings = async () => {
  const response = await api.get('/payments/prodamus/settings');
  return response.data;
};

export const saveProdamusSettings = async (settings) => {
  const response = await api.post('/payments/prodamus/settings', settings);
  return response.data;
};

export const getPaymentProviders = async () => {
  const response = await api.get('/payments/providers');
  return response.data;
};

export const getPaymentQuote = async (plan, provider, promoCode = null) => {
  const params = { plan, provider };
  if (promoCode) {
    params.promoCode = promoCode;
  }
  const response = await api.get('/payments/quote', { params });
  return response.data;
};

export const createPayment = async (plan, amount, returnUrl, promoCode = null, provider) => {
  const payload = { plan, amount, returnUrl, provider };
  if (promoCode) {
    payload.promoCode = promoCode;
  }
  const response = await api.post('/payments/create', payload);
  if (response.data.paymentId) {
    localStorage.setItem('lastPaymentId', response.data.paymentId);
  }
  return response.data;
};

export const getPaymentStatus = async (paymentId) => {
  const response = await api.get(`/payments/status/${paymentId}`);
  return response.data;
};

export const getPaymentHistory = async () => {
  const response = await api.get('/payments/history');
  return response.data;
};

export const createCreditPayment = async (packageId, amount, returnUrl, provider) => {
  const response = await api.post('/payments/create', {
    plan: `credits_${packageId}`,
    amount,
    returnUrl,
    provider
  });
  if (response.data.paymentId) {
    localStorage.setItem('lastPaymentId', response.data.paymentId);
  }
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await api.post('/payments/subscription/cancel');
  return response.data;
};

export const removePaymentMethod = async () => {
  const response = await api.delete('/payments/payment-method');
  return response.data;
};
